import React from 'react';
import {
  Switch, Route, withRouter
} from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from 'app/shared/store';
import routes from 'app/categoryApp/routes';
import {
  CategoryOverview
} from 'app/categoryApp/Views';
import {Provider} from 'react-redux';
import PropTypes from 'prop-types';

const CategoryApp = (props) => {
  let path = window.location.pathname ?? routes.category.url;
  // get the last part of the path
  const pathParts = path.split('/');
  path = '/' + pathParts[pathParts.length - 1];
  
  const pathPrefix = path;
  if (window.location.hash === '#/') {
    window.location.hash += path.indexOf('/') === 0 ? path.substring(1) : path;
  }
  let prefilterWithCategory = false;
  const containsSearch = props.prefilter.indexOf('?');
  if (containsSearch > 0) {
    prefilterWithCategory = true;
  }
  if (props.showQuickFilter || prefilterWithCategory) {
    path += '/:category?';
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Switch>
          <Route exact path={path} render={() => <CategoryOverview {...props} path={pathPrefix}/>}/>
        </Switch>
      </PersistGate>
    </Provider>
  );
};

CategoryApp.propTypes = {
  showQuickFilter: PropTypes.bool,
  prefilter: PropTypes.string
};

export default withRouter(CategoryApp);
